// extracted by mini-css-extract-plugin
export default {"notificationContainer":"NotificationContainer_notificationContainer__twWvj"};